import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * Errors come in in with type unknown, but from the Sink interface:
 *
 * An error that has occured. Calling this function "closes" the sink.
 * Besides the errors being `Error` and `readonly GraphQLError[]`, it
 * can also be a `CloseEvent`, but to avoid bundling DOM typings because
 * the client can run in Node env too, you should assert the close event
 * type during implementation.
 *
 * error(error: unknown): void;
 */

export var getSinkError = function getSinkError(error) {
  var errorInfo;
  if (Array.isArray(error)) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    var _ref = error;
    var _ref2 = _slicedToArray(_ref, 1);
    errorInfo = _ref2[0];
  } else if (error instanceof Error) {
    errorInfo = error;
  } else if (_typeof(error) === 'object' && 'type' in error && error.type === 'close') {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error("CloseEvent: ".concat(error.reason));
  } else if (_typeof(error) === 'object' && 'type' in error && error.type === 'error') {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    var errorEvent = error;
    errorInfo = new Error("ErrorEvent: \"".concat(errorEvent.error, "\""));
  } else if (error instanceof Event) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error("Event: ".concat(error.type));
  } else {
    errorInfo = new Error("Unknown sink error: ".concat(error));
  }
  if (error instanceof Error && error.stack) {
    errorInfo.stack = error.stack;
  }
  return errorInfo;
};